import { Device, NetworkDevice } from '../../index';

const outputsToExlude = ['semsa', 'countermeter', 'audiocontrol'];

export function filterOutputs<T extends Device | NetworkDevice>(device: T): T {
  if (device.functionblocks)
    device.functionblocks = device.functionblocks.filter((fb) => {
      const name = fb?.type?.name;
      return !outputsToExlude.includes(name || '');
    });

  if ((device as Device).networkDevices) {
    (device as Device).networkDevices = filterOutputsOnDevices(
      (device as Device).networkDevices || []
    );
  }

  return device;
}

export function filterOutputsOnDevices<T extends Device | NetworkDevice>(
  devices: T[]
): T[] {
  return devices.map(filterOutputs);
}
